import {Component, OnDestroy, OnInit} from '@angular/core';
import {ProjectConstants} from '../../../project-constants';
import {FormBuilder, FormGroup, NgForm, Validators} from '@angular/forms';
import {Subscription} from 'rxjs';
import {ActivatedRoute, Router} from '@angular/router';
import * as toastr from 'toastr';
import {SizeAnagrafService} from '../../../general-services/service-size-anagraf/size-anagraf.service';
import {SizeModel} from '../../../../models/SizeModel';

@Component({
  selector: 'app-new-size-anagraf',
  templateUrl: './new-size-anagraf.component.html',
  styleUrls: ['./new-size-anagraf.component.scss']
})
export class NewSizeAnagrafComponent extends ProjectConstants implements OnInit, OnDestroy {
  size: SizeModel;
  formValidator: FormGroup;
  formBuilder: FormBuilder;
  saveSubscribe: Subscription;

  constructor(private route: ActivatedRoute, private router: Router,
              private sizeService: SizeAnagrafService) {
    super();

    this.size = new SizeModel();

    this.formBuilder = new FormBuilder();

    this.formValidator = this.formBuilder.group({
      cod: [this.size.cod, [Validators.required]],
      description: [this.size.description, [Validators.required]]
    });
  }

  ngOnInit() {

  }

  cancel(event: any) {
    event.preventDefault();
    this.router.navigate([this.LINKS.MASTER_DATA + this.LINKS.ANAGRAPH.SIZE_ANAGRF]);
  }

  save(event: any, form: NgForm, clickSalva ?: boolean) {
    if (event.key === 'Enter' || clickSalva) {
      event.preventDefault();
      this.size.cod = this.formValidator.value.cod;
      this.size.description = this.formValidator.value.description;
      this.saveSubscribe = this.sizeService.save(this.sizeService.baseUrl, this.size).subscribe(
        (result: any) => {
          if (result === -1) {
            toastr.options.timeout = 5000;
            toastr.warning('Duplicate item, Size Cod already exists', 'Warning');
          } else {
            toastr.success('Size was added with success', 'Success');
            this.router.navigate([this.LINKS.MASTER_DATA + this.LINKS.ANAGRAPH.SIZE_ANAGRF]);
          }
        });
    }
  }

  ngOnDestroy(): void {
    if (this.saveSubscribe) {
      this.saveSubscribe.unsubscribe();
    }
  }

  // convenience getter for easy access to form fields
  get fv() { return this.formValidator.controls; }

}
